import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';
import {StockService} from '../../services/stock/stock.service';
import {Stock} from '../../models/stock';
import {Store} from '../../models/store';
import {Household} from '../../models/household';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import { AppLogger, AppLoggerService } from '../../core/logging';

@Component({
    selector: 'app-search-stock',
    templateUrl: './search-stock.component.html',
    styleUrls: ['./search-stock.component.scss'],
    standalone: false
})
export class SearchStockComponent implements OnInit {

  private readonly tag = '[SearchStock]';

  private readonly log: AppLogger;

  @Input() household: Household;
  @Input() store: Store;
  @Input() minCharacter = 2;
  @Input() autoSearch = false;

  searchForm: UntypedFormGroup;

  @Output() searchStarted = new EventEmitter<boolean>();
  @Output() searchCompleted = new EventEmitter<Stock[]>();
  @Output() emptySearch = new EventEmitter<boolean>();

  // Indicates if the component is ready to work
  ready = false;

  faClose = faTimes;

  constructor(
    private stockService: StockService,
    private formBuilder: UntypedFormBuilder,
    private appLogger: AppLoggerService
  ) {
    this.log = this.appLogger.createForClass(SearchStockComponent);
  }

  ngOnInit(): void {
    this.log.info('Initialize stock search');

    this.searchForm = this.formBuilder.group({
      query: ''
    });

    if (this.household) {
      this.ready = true;
    }
  }

  onSearchChange(): void {
    if (this.autoSearch) {
      this.search();
    }
  }

  onSearchClick(): void {
    this.search();
  }

  onSearchClearClick(): void {
    this.searchForm.reset();
  }

  search(): void {

    const query = this.searchForm.value.query;
    this.log.debug('Stock search triggered', { query });

    if (query.length >= this.minCharacter) {
      this.searchStarted.emit(true);

      if (this.store !== undefined && this.store.id > 0) {
        this.stockService.searchStockByStoreAndName(query, this.store.id).subscribe((stocks) => {
          this.searchCompleted.emit(stocks);
        });
      } else {
        this.stockService.searchStockByName(query, this.household.id).subscribe((stocks) => {
          this.searchCompleted.emit(stocks);
        });
      }

    } else {
      this.emptySearch.emit(true);
    }
  }

}
